import { createEffect, createMemo, createSignal, on } from "solid-js";

import { isMobile } from "@/lib/isMobile";

// import "@/styles/motion/zoom.css";

import { type FlowProps } from "../../../types/base.ts";
import "./Index.css";

type AnimationDirection = "left" | "right" | "center" | "none";

interface TransitionProps extends FlowProps {
  direction?: AnimationDirection;
  shouldExit?: boolean;
  onAnimationEnd?: () => void;
}

export const RouteTransitionWrapper = (props: TransitionProps) => {
  const [animationClass, setAnimationClass] = createSignal("");
  let divRef: HTMLDivElement | undefined;

  // 监听shouldExit变化并更新动画类
  createEffect(
    on(
      createMemo(() => {
        const baseDirection = props.direction || "";
        const exitClass = props.shouldExit ? "exit" : "";
        return `${baseDirection} ${exitClass}`.trim();
      }),
      (newClass) => setAnimationClass(newClass),
    ),
  );

  // 处理动画结束事件
  const handleAnimationEnd = (e: AnimationEvent) => {
    // 只处理退出动画的结束事件
    if (props.shouldExit && divRef && e.target === divRef) {
      props.onAnimationEnd?.();
    }
  };

  return (
    <div
      ref={(el) => (divRef = el)}
      class={`relative h-full w-full ${isMobile() ? "transition-container" : "route-transition"} ${animationClass()}`}
      onAnimationEnd={handleAnimationEnd}
    >
      {props.children}
    </div>
  );
};
